export default __webpack_public_path__ + "static/media/circle-with-logo.26a7fdb1.png";